/**
 * Маркеры номера дома. Пока номер не набран, они остаются в хвосте запроса
 * («ул. Тифлисская, д.») и ФИАС не находит по ним ничего: поиск объектов идёт
 * вхождением строки в название. Список зеркалит `houseMarkers` из
 * `fias/internal/application/address/service.go`.
 */
const HOUSE_MARKERS = new Set([
  'д',
  'д.',
  'дом',
  'влд',
  'влд.',
  'владение',
  'к',
  'к.',
  'корп',
  'корп.',
  'корпус',
  'стр',
  'стр.',
  'строение',
  'лит',
  'лит.',
  'литера',
  'соор',
  'соор.',
  'сооружение',
])

const TRAILING_SEPARATORS = /[\s,]+$/

/**
 * Готовит строку ввода к отправке в `/fias/suggest`: снимает хвостовые
 * разделители и «висящие» маркеры дома. Без этого при наборе адреса
 * промежуточные состояния («ул. Тифлисская,») дают пустую выдачу, хотя сама
 * улица находится. Цифры не трогаем — по ним бэкенд как раз ищет дома.
 */
export const normalizeSuggestQuery = (raw: string): string => {
  let query = raw.trim().replace(TRAILING_SEPARATORS, '')

  for (;;) {
    const index = Math.max(query.lastIndexOf(' '), query.lastIndexOf(','))
    if (index < 0) return query

    const tail = query
      .slice(index + 1)
      .trim()
      .toLowerCase()
    if (!HOUSE_MARKERS.has(tail)) return query

    query = query.slice(0, index).replace(TRAILING_SEPARATORS, '')
  }
}
